<template>
  <div class="operationMan">
    <!-- <header-bar></header-bar> -->
  <div class="applyVFHead">
  <div class="applyVFMansel">
     {{$t('message.partner')}}：
           <!-- <select-menu :partData="partData" @change="changeHandler"></select-menu> -->
            <el-select v-model="valuePa" placeholder="请选择" @change="changeHandler" class="selectCss" filterable>
            <el-option
             v-for="item in partData"
             :key="item.partnerNo"
             :label="item.loginName"
             :value="item.partnerNo">
            </el-option>
          </el-select>
          {{$t('message.area')}}：
          <!-- <select-men :areaData="areaData" @change="changeArea"></select-men> -->
            <el-select v-model="valueAr" placeholder="请选择" @change="changeArea" class="selectCss" filterable>
           <el-option
            v-for="item in areaData"
            :key="item.partnerareaguid"
            :label="item.Partnerareaname"
            :value="item.partnerareaguid">
          </el-option>
         </el-select>
          <el-dropdown @command="userOperation" class="dropName">
                        <span class="user">{{this.$cookies.get("LoginName")}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown" class="dropst">
                            <el-dropdown-item command="editPsd">{{$t('message.changePSD')}}</el-dropdown-item>
                            <!-- <el-dropdown-item command="editSecPsd">{{$t('message.changeSecPSD')}}</el-dropdown-item> -->
                            <el-dropdown-item command="logout">{{$t('message.exit')}}</el-dropdown-item>
                        </el-dropdown-menu>
            </el-dropdown>
        </div>
        <lang-select class="drops" @handIt="loadAgain"></lang-select>
    </div>
    <div class="applyVFMain">
        <div class="applyAdiv">
            <el-button type="primary" icon="el-icon-circle-plus-outline" class="applyABtn" @click="addNewVF">{{$t('message.sqAdd')}}</el-button>
        </div>
                      <div class="applyHead">
                          <el-tabs v-model="activeName" @tab-click="manhandleClick" class="fetab">
                            <el-tab-pane :label="$t('message.ddSH')" name="0"></el-tab-pane>
                            <el-tab-pane :label="$t('message.SHPass')" name="1"></el-tab-pane>
                            <el-tab-pane :label="$t('message.SQReturn')" name="-1"></el-tab-pane>
                          </el-tabs>
                        </div>
                        <div class="manTable">
                            <el-table
                               :data="manData"
                               v-loading="manloading"
                               style="width: 100%"
                                >
                             <el-table-column
                               :label="$t('message.userName')"
                                prop="UserRealName"
                             >
                             </el-table-column>

                             <el-table-column
                                prop="UserPhone"
                                :label="$t('message.phone')"
                                >
                              </el-table-column>

                             <el-table-column
                                prop="Penalty"
                                :label="$t('message.fkMoney')"
                                >
                              </el-table-column>

                                <el-table-column
                                 prop="FineDescription"
                                :label="$t('message.fkDesc')"
                                >
                              </el-table-column>

                                <el-table-column
                                :label="$t('message.fkDan')"
                                >
                                 <template scope="scope">
                                  <div >
                                   <img :src="Lookpic" alt="" @click="showImg(scope.row.FineBillImageName)">
                                  </div>
                                </template>
                              </el-table-column>


                              <el-table-column
                                prop="Operator"
                                :label="$t('message.SQPerson')"
                                >
                              </el-table-column>

                              <el-table-column
                                 prop="OperationTime"
                                :label="$t('message.SQTime')"
                                >
                              </el-table-column>
                          
  
                               <el-table-column
                                 prop="LastOperator"
                                :label="activeName==1?$t('message.SHPerson'):$t('message.QXPerson')"
                                v-if="activeName!=0"
                                >
                                 
                              </el-table-column>
                              <el-table-column
                                 prop="LastOperationTime"
                                :label="activeName==1?$t('message.SHTime'):$t('message.QXTime')"
                                 v-if="activeName!=0"
                                >
                                 
                              </el-table-column>

                             <el-table-column
                                 prop="CancelReason"
                                :label="$t('message.QXReason')"
                                v-if="activeName==-1"
                                > 
                              </el-table-column>
                             </el-table> 
                        </div>    
                      </div>

                      <el-dialog :title="$t('message.addFKD')" :visible.sync="AFVisible"  width="45%">
                         <el-form ref="form" :model="form" label-width="80px" id="form">
                            <el-form-item :label="$t('message.phone')">
                              <el-input v-model="form.phone"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('message.fkMoney')">
                              <el-input v-model="form.Penalty"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('message.fkDesc')">
                              <el-input v-model="form.fineDescription"></el-input>
                            </el-form-item>
                             <el-form-item :label="$t('message.fkDan')">
                              <el-upload
                                class="avatar-uploader"
                                :show-file-list="false"
                                action
                                ref="upload"
                                :http-request="fnUploadRequest"
                                :limit="1"
                                :drag="true"
                                accept=".jpeg,.jpg,.png,.ico"
                                :before-upload="beforeAvatarUpload"
                                :file-list="fileArr"
                              >
                               <img v-if="card.imgUrl" :src="card.imgUrl" class="upImg" />
                               <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                             </el-form-item>
                          </el-form>
                         <div slot="footer" class="dialog-footer">
                             <el-button @click="AFVisible = false">{{$t('message.cancels')}}</el-button>
                             <el-button type="primary" @click="sureNewAF">{{$t('message.sure')}}</el-button>
                         </div>
                        </el-dialog>

      <el-dialog
      :title="$t('message.changePSD')"
      :visible.sync="editPSDS"
      width="24%"
      >
      <el-form ref="form" :model="formm" label-width="80px">
       <el-form-item :label="$t('message.oldPSD')">
        <el-input v-model="formm.oldpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.newPSD')">
        <el-input v-model="formm.newpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.suerPSD')">
        <el-input v-model="formm.surepsd" type="password"></el-input>
       </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="editPSDS = false">{{$t('message.cancels')}}</el-button>
      <el-button type="primary" @click="changePsds">{{$t('message.sure')}}</el-button>
      </span>
     </el-dialog>

      <el-dialog
      :title="$t('message.changeSecPSD')"
      :visible.sync="editSecPSDS"
      width="26%"
      >
      <el-form ref="form" :model="formmSec" label-width="100px">
       <el-form-item :label="$t('message.oldSecPsd')">
        <el-input v-model="formmSec.oldpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.newSecPsd')">
        <el-input v-model="formmSec.newpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.suerSecPsd')">
        <el-input v-model="formmSec.surepsd" type="password"></el-input>
       </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="editSecPSDS = false">{{$t('message.cancels')}}</el-button>
      <el-button type="primary" @click="changeSecPsds">{{$t('message.sure')}}</el-button>
      </span>
     </el-dialog>

      <el-dialog
        :title="$t('message.sysTit')"
        :visible.sync="dialogOuti"
        width="30%"
      >
       <span>{{soneIns}}</span>
       <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOuti = false">{{$t('message.cancels')}}</el-button>
        <el-button type="primary" @click="logout">{{$t('message.sure')}}</el-button>
       </span>
      </el-dialog>

      <el-dialog
        title="查看图片"
        :visible.sync="picVisible"
        width="30%"
      >
        <img :src="backImg" class="backImg"/> 
      </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import md5 from "js-md5";
import SelectMenu from "@/components/SelectMenu.vue";
import SelectMen from "@/components/SelectMen.vue";
import LangSelect from "@/components/LangSelect.vue";
import Vue from "vue";

import OSS from "ali-oss";
import * as imageConversion from 'image-conversion';
export default {
  name: "ApplyViolationFineInformation",
  data() {
    return {
      fileArr: [],
      picVisible: false,
      backImg: "",
      Lookpic: require("../../assets/LookPic.png"),
      strFour: "",
      loading: false,
      card: {
        imgUrl: ""
      },
      AFVisible: false,
      soneIns: "",
      dialogOuti: false,
      editSecPSDS: false,
      formmSec: {
        oldpsd: "",
        newpsd: "",
        surepsd: ""
      },
      valuePa: "",
      valueAr: "",
      editPSDS: false,
      formm: {
        oldpsd: "",
        newpsd: "",
        surepsd: ""
      },
      partData: "",
      areaData: "",
      activeName: "0",
      manloading: true,
      manData: [],
      form: {
        phone: "",
        Penalty: "",
        fineDescription: ""
      },
      fineBillImageName: ""
    };
  },
  created() {
    this.loadPartner();
  },
  updated() {},
  mounted() {},
  computed: {
    // myData() {
    //   return {
    //     languagecode: "zh_CN"
    //   };
    // }
  },
  watch: {},
  methods: {
    showImg(picUrl) {
      this.backImg = "";
      this.backImg = picUrl;
      this.picVisible = true;
    },
    f1() {
      this.strFour = "";
      var that = this;
      var arr_4 = new Array();
      function getRandom(
        min,
        max //开始取数
      ) {
        //随机数
        var random = Math.random() * (max - min) + min;
        //向下取整
        random = Math.floor(random);

        if (arr_4.length < 4) {
          //判断数组长度
          for (
            var i = 0;
            i <= arr_4.length;
            i++ //遍历数组。
          ) {
            if (random == arr_4[i]) {
              //比较随机数
              break;
            } else {
              if (i == arr_4.length) {
                arr_4.push(random);
                break;
              }
            }
          }
          getRandom(0, 10);
        }
      }
      getRandom(0, 10); //随机取0-9

      for (var j = 0; j < arr_4.length; j++) {
        that.strFour += arr_4[j] + "";
      }
    },
    async fnUploadRequest(option) {
      this.fineBillImageName = "";
      this.f1();
      try {
        // console.log("参数", option);
        this.loading = true;
        // 获取OSS配置信息
        // let client = new OSS({
        //   accessKeyId: "LTAI4Fod2uUUv1Y3hHX5QShi",
        //   accessKeySecret: "oh6kfT0QihZn6f4YV7rMrbE0vlH13B",
        //   bucket: "mimacx-img-oss",
        //   region: "oss-cn-hangzhou"
        // });

        let client = new OSS({
          accessKeyId: "LTAI4FiAkmPFxWwPyhrydSLa",
          accessKeySecret: "H7ptcMTqV49TZ6kaRikwip1dCCUTDF",
          bucket: "mimaimage",
          region: "oss-cn-shanghai"
        });

        let file = option.file;
        const point = file.name.lastIndexOf(".");
        let suffix = file.name.substr(point);
        let fileNames =
          "FK" + this.GLOBAL.timestamp + this.strFour + `${suffix}`;
        this.fineBillImageName = fileNames;
        let relativePath = "serviceItem/";
        // console.log("oss客户端", client);
        // console.log("文件", file);
        // 分片上传文件
        let ret = await client.multipartUpload(fileNames, file, {
          progress: async function(p) {
            let e = {};
            e.percent = p * 100;
            option.onProgress(e);
          }
        });
        if (ret.res.statusCode === 200) {
          // console.log("上传成功", ret);
          this.card.imgUrl = ret.res.requestUrls[0].split("?")[0];
          this.fileArr = [];
        } else {
          this.fileArr = [];
          option.onError("上传失败");
        }
      } catch (error) {
        // console.error(error);
        this.fileArr = [];
        option.onError("上传失败");
      }
      this.loading = false;
    },
    // /**
    //  * 图片限制
    //  */
    beforeAvatarUpload(file) {
      // const isJPEG = file.name.split(".")[1] === "jpeg";
      // const isJPG = file.name.split(".")[1] === "jpg";
      // const isPNG = file.name.split(".")[1] === "png";
      // const isLt500K = file.size / 1024 / 500 < 2;
      // if (!isJPG && !isJPEG && !isPNG) {
      //   this.$message.error("上传图片只能是 JPEG/JPG/PNG 格式!");
      // }
      // if (!isLt500K) {
      //   this.$message.error("单张图片大小不能超过 500KB!");
      // }
      // return (isJPEG || isJPG || isPNG) && isLt500K;
      return new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let isLt2M = file.size / 1024 / 1024 > 0.5; // 判定图片大小是否小于0.5MB
        // 这里需要计算出图片的长宽
        let img = new Image();
        img.onload = function() {
          file.width = img.width; // 获取到width放在了file属性上
          file.height = img.height; // 获取到height放在了file属性上
          let valid = img.width > 1000; // 图片宽度大于2000
          // console.log("压缩前", file);
          // 这里我只判断了图片的宽度,compressAccurately有多个参数时传入对象
          if (valid || isLt2M) {
            // 大小在500k以下，宽度1000以下
            imageConversion
              .compressAccurately(file, {
                size: 500,
                width: 1000
              })
              .then(res => {
                // console.log("压缩后", res);
                resolve(res);
              });
          } else {
            resolve(file);
          }
        }; // 需要把图片赋值
        img.src = _URL.createObjectURL(file);
      });
    },

    addNewVF() {
      this.form.phone = "";
      this.form.Penalty = "";
      this.form.fineDescription = "";
      this.card.imgUrl = "";
      this.AFVisible = true;
    },
    sureNewAF() {
      if (this.form.phone == "") {
        this.$message.error("请输入手机号");
        return;
      }
      if (!this.GLOBAL.PhontRegst.test(this.form.phone)) {
        this.$message.error("手机号输入不正确");
        return;
      }
      if (this.form.Penalty == "") {
        this.$message.error("请输入罚款金额");
        return;
      }
      if (this.form.fineDescription == "") {
        this.$message.error("请输入罚款描述");
        return;
      }
      if (this.fineBillImageName == "") {
        this.$message.error("请选择上传图片");
        return;
      }
      var params = new URLSearchParams();
      // params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      // params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("id", this.$cookies.get("ID"));
      params.append("pwd", this.$cookies.get("pwd"));
      params.append("Token", this.$cookies.get("Token"));
      params.append("DbMapCountryRegionCode", "greaterchina");

      params.append("AreaGuid", this.$cookies.get("areaValue"));
      params.append("UserPhone", this.form.phone);
      params.append("Penalty", this.form.Penalty);
      params.append("FineDescription", this.form.fineDescription);
      params.append("FineBillImageName", this.fineBillImageName);
      params.append("loginName", this.$cookies.get("LoginName"));
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      this.$axios({
        url: "/PartnerRelated/EnterViolationFineInformation",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          if (res.data.status == "success") {
            // console.log(res.data.data);
            this.AFVisible = false;
            this.fineBillImageName = "";
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.reload();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    loadPartner() {
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("partnerno", this.$cookies.get("pno"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/BiNdiNg_PartneR",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          if (res.data.status == "success") {
            this.partData = res.data.data;
            var partV = this.$cookies.get("partner");
            if (partV == null) {
              this.valuePa = this.partData[0].partnerNo;
            } else {
              this.valuePa = this.$cookies.get("partner");
            }
            this.$cookies.set("partner", this.valuePa);
            this.loadArea();
          } else if (res.data.status == "re_login") {
            this.soneIns = res.data.message;
            this.dialogOuti = true;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    loadArea() {
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerno", this.$cookies.get("partner"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/BiNdiNg_PartneR_aReA",
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          this.areaData = res.data.data;
          var areaV = this.$cookies.get("areaValue");

          if (areaV == null) {
            this.valueAr = this.areaData[0].partnerareaguid;
          } else {
            for (var i = 0; i < this.areaData.length; i++) {
              if (
                this.areaData[i].partnerareaguid ==
                this.$cookies.get("areaValue")
              ) {
                this.valueAr = this.$cookies.get("areaValue");
              } else {
                this.valueAr = this.areaData[0].partnerareaguid;
              }
            }
          }
          this.$cookies.set("areaValue", this.valueAr);
          this.$cookies.set(
            "dbMapCode",
            this.areaData[0].dbmapcountryregioncode
          );
          this.$cookies.set("nation", this.areaData[0].nation);
          //调用接口
          this.LoadmanList(this.activeName);
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeHandler() {
      // this.$cookies.set("areaValue", areaVal);
      this.$cookies.set("partner", this.valuePa);
      this.loadArea();
    },
    changeArea() {
      this.$cookies.set("areaValue", this.valueAr);
      this.LoadmanList(this.activeName);
    },
    userOperation(command) {
      switch (command) {
        case "logout":
          this.logout();
          break;
        case "editPsd":
          if (this.$cookies.get("LoginType") == "1") {
            this.$message.error(this.$t("message.marketNoPSD"));
            return;
          }
          this.formm.oldpsd = "";
          this.formm.newpsd = "";
          this.formm.surepsd = "";
          this.editPSDS = true;
          // console.log("编辑密码");
          break;
        case "editSecPsd":
          if (this.$cookies.get("LoginType") == "1") {
            this.$message.error(this.$t("message.marketNoSecPSD"));
            return;
          }
          this.formmSec.oldpsd = "";
          this.formmSec.newpsd = "";
          this.formmSec.surepsd = "";
          this.editSecPSDS = true;
          break;
      }
    },
    logout() {
      this.$cookies.set("SaveSiaLog", 2);
      this.$router.push("./login");
    },
    loadAgain() {
      this.loadPartner();
    },
    changeSecPsds() {
      if (this.formmSec.oldpsd == "") {
        this.$message.error(this.$t("message.oldSecPsdNo"));
        return;
      }
      if (this.formmSec.oldpsd != this.$cookies.get("saveSecond")) {
        this.$message.error(this.$t("message.psdNoOldPsd"));
        return;
      }
      if (this.formmSec.oldpsd.length < 6) {
        this.$message.error(this.$t("message.psdNolessBa"));
        return;
      }

      if (this.formmSec.newpsd == "") {
        this.$message.error(this.$t("message.newSecPsdNo"));
        return;
      }
      if (this.formmSec.newpsd.length < 6) {
        this.$message.error(this.$t("message.newSecNolessba"));
        return;
      }
      if (this.formmSec.newpsd != this.formmSec.surepsd) {
        this.$message.error(this.$t("message.surePsdNoNew"));
        return;
      }
      var randomNum = Math.random();
      var params = new URLSearchParams();
      params.append("loginName", this.$cookies.get("LoginName"));
      params.append("oldSecondPwd", this.formmSec.oldpsd);
      params.append("newSecondPwd", this.formmSec.newpsd);
      // params.append(
      //   "secretKey",
      //   md5(this.GLOBAL.timestamp.toString() + randomNum.toString())
      // );
      // params.append("randomNum", randomNum);
      params.append("partnerGuid", this.$cookies.get("partner"));

      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/updateSecondPwd",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        // withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            this.editSecPSDS = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.$cookies.set("saveSecond", this.formmSec.newpsd);
            this.$cookies.set("SaveSiaLog", 2);
          } else {
            this.$message.error(res.data.message);
            this.$cookies.set("SaveSiaLog", 1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    LoadmanList(status) {
      this.manData = [];
      this.manloading = true;
      var params = new URLSearchParams();
      // params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      // params.append("Nation", this.$cookies.get("nation"));
      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("id", this.$cookies.get("ID"));
      params.append("pwd", this.$cookies.get("pwd"));
      params.append("Token", this.$cookies.get("Token"));
      params.append("languagecode", this.$i18n.locale);
      params.append("AreaGuid", this.$cookies.get("areaValue"));
      params.append("Status", status);
      params.append("loginName", this.$cookies.get("LoginName"));
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("DbMapCountryRegionCode", "greaterchina");
      this.$axios({
        url: "/PartnerRelated/ViolationFineInformationList",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          // console.log(res.data.data);
          if (res.data.status == "success") {
            // console.log(res.data.data);
            this.manloading = false;
            this.manData = res.data.data[0].dataRows;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    manhandleClick(tab) {
      this.activeName = tab.name;
      this.LoadmanList(this.activeName);
    },
    reload() {
      this.LoadmanList(this.activeName);
    },
    changePsds() {
      if (this.formm.oldpsd == "") {
        this.$message.error(this.$t("message.oldPSDNON"));
        return;
      }
      if (this.formm.oldpsd != this.$cookies.get("oldPassword")) {
        this.$message.error(this.$t("message.enternosame"));
        return;
      }
      // if (this.formm.oldpsd.length < 6) {
      //   this.$message.error(this.$t("message.oldPSDNSix"));
      //   return;
      // }

      if (this.formm.newpsd == "") {
        this.$message.error(this.$t("message.newPSDNON"));
        return;
      }
      // if (this.formm.newpsd.length < 6) {
      //   this.$message.error(this.$t("message.oldPSDNSix"));
      //   return;
      // }
      if (this.formm.newpsd != this.formm.surepsd) {
        this.$message.error(this.$t("message.psdNoSame"));
        return;
      }
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));

      params.append("loginName", this.$cookies.get("LoginName"));
      params.append("oldPwd", this.formm.oldpsd);
      params.append("newPwd", this.formm.newpsd);
      params.append("partnerGuid", this.$cookies.get("partner"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/EdiT_PaSsWoRd",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          if (res.data.status == "success") {
            // console.log(res.data.data);
            this.editPSDS = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            setTimeout(() => {
              this.$router.push("./login");
            }, 2000);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  components: {
    SelectMenu,
    SelectMen,
    LangSelect
  }
};
</script>
<style>
.applyVFHead {
  height: 64px;
  background: #000;
}
.applyVFMansel {
  float: right;
  color: #fff;
  padding-top: 12px;
}
.applyVFMain {
  padding: 10px;
}
.applyAdiv {
  text-align: center;
  margin-bottom: 10px;
}
.applyABtn {
  width: 361px !important;
}
.applyHead {
  height: 50px;
  line-height: 50px;
  width: 98%;
  background-color: #ffffff;
  padding: 0 10px;
}

.backImg {
  width: 400px;
  height: 400px;
}
.upImg {
  width: 100%;
}
</style>
